import { render } from "./ChevronUpIcon.vue?vue&type=template&id=4bed0d37"
import script from "./ChevronUpIcon.vue?vue&type=script&lang=js"
export * from "./ChevronUpIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__